import { Button } from '@mui/material';
import styled from 'styled-components';

export const DetailHeader = styled.div`
  display: flex;
  align-items: baseline;
  margin-bottom: 18px;
`;

export const ReturnToListContainer = styled.div`
`;

export const ReturnToList = styled(Button)`
  color: var(--luft-primary);
  font-weight: 500;
  text-transform: none;
  font-size: 13px;
  gap: 8px;
  padding: 0;
  height: 30px;
`;

export const SecondReceiptLabel = styled.span`
  color: var(--luft-primary);
  margin-bottom: 4px;
  font-size: 16px;
  font-weight: 700;
`;

export const HeaderItemContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ColumnItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const HeaderItem = styled.div`
  color: var(--operationalDashboard-text-secondary);
  font-size: 14px;
`;

export const Item = styled.div`
  color: var(--primary-main, #263465);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`;

export const ReceiptStatus = styled.div`
  font-size: 14px;
  color: var(--light-opacity-gray);
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const HistoryText = styled.div`
  color: var(--light-blue);
  cursor: pointer;
`;
